import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from 'components/atoms/switch/switch';
import { Tag } from 'components/atoms/tag';
import { getRandomColor } from 'utils/get-random-color';
export const ReasonCodeRenderer = ({ data })=>{
    return /*#__PURE__*/ _jsx(Tag, {
        color: getRandomColor(data.reasonId),
        children: data.reason
    }, data.reasonId);
};
export const StatusRenderer = ({ data, onUpdateStatus })=>{
    return /*#__PURE__*/ _jsx(Switch, {
        size: "small",
        checked: data.active,
        onChange: (checked)=>onUpdateStatus(data.reasonId, checked)
    });
};
